// Configuración base
const isLocalPaymentRunning = false; // Cambiar a `false` si payment NO está corriendo localmente
const isLocalPaymentGatewayRunning = false; // Cambiar a `false` si payment gateway NO está corriendo localmente


const envConfig = {
  dev: {
    url_payment_api: isLocalPaymentRunning ? "http://localhost:3000" : "https://payments-stg.alvearsupermercados.com.ar/api", //usar la url donde este corriendo payment
    url_payment_gateway: isLocalPaymentGatewayRunning ?  "http://localhost:3333/build" : "https://payments-stg.alvearsupermercados.com.ar/frontend", //usar la url donde este corriendo payment gateway
    url_backend: "https://4jnspdkn-44331.brs.devtunnels.ms", //es necesario hacer un tunel al backend para que payment pueda mandarle la notificacion del pago
    url_front: isLocalPaymentRunning ? "http://localhost:3002" : "https://4jnspdkn-3002.brs.devtunnels.ms", //si payment esta corriendo localmente usa el localhost 3000, por lo que el front se levanta en localhost:3002
    prefix_tittle: 'dev - '
  },
  test: {
    url_payment_api: isLocalPaymentRunning ? "https://4jnspdkn-3000.brs.devtunnels.ms"  : "https://payments-stg.alvearsupermercados.com.ar/api",
    url_payment_gateway: isLocalPaymentRunning ? "https://4jnspdkn-3333.brs.devtunnels.ms/build": "https://payments-stg.alvearsupermercados.com.ar/frontend",
    url_backend: "https://staging.alvearonline.com.ar/BackOnline",
    url_front: "https://staging.alvearonline.com.ar",
    prefix_tittle: 'Staging - '
  },
  prod: {
    url_payment_api: "https://payments.alvearsupermercados.com.ar/api",
    url_payment_gateway: "https://payments.alvearsupermercados.com.ar/frontend",
    url_backend: "https://alvearonline.com.ar/BackOnline",
    url_front: "https://alvearonline.com.ar",
    prefix_tittle: ''
  }
};

// Selección del entorno (puedes cambiarlo según tu necesidad)
const currentEnv = 'test'; // Cambiar a 'test' o 'prod' según corresponda

// Exporta las URLs dinámicamente
export const {
  url_payment_api,
  url_payment_gateway,
  url_backend,
  url_front,
  prefix_tittle
} = envConfig[currentEnv];